import { useModalContext } from 'components/system/ModalContext';
import PaymentMethodForm from 'components/pages/Payments/PaymentMethodForm';
import usePaymentMethod from 'hooks/usePaymentMethod';
import { useGetBalance } from 'hooks/useBillingAccount';
import { useQueryClient } from 'react-query';

const withAttachCardDialog = (Component, { isClosable = true } = {}) => ({ ...props }) => {
  const { openModal, closeModal } = useModalContext();
  const queryClient = useQueryClient();
  const { refetch: refetchPaymentMethod } = usePaymentMethod();
  const { refetch: refetchBalance } = useGetBalance();

  const handlePaymentMethodAdded = async () => {
    await refetchPaymentMethod();
    await refetchBalance();
    // Fixme: revisit refetch queries
    await queryClient.refetchQueries('account');
    if (isClosable) {
      closeModal();
    }
  };

  const openAttachCardModal = () => {
    openModal({
      content: (
        <PaymentMethodForm onSubmitCallback={handlePaymentMethodAdded} />
      ),
    });
  };

  return (
    <Component
      {...props}
      openAttachCard={openAttachCardModal}
    />
  );
};

export default withAttachCardDialog;
